"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInfoIcon = exports.StyledSearchBar = exports.StyledWidgetHeading = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const search_bar_1 = require("../../preview-products-widget/search-bar");
const icons_1 = require("../../../icons");
exports.StyledWidgetHeading = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(9)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledSearchBar = (0, styled_components_1.default)(search_bar_1.SearchBar) `
  && {
    height: ${({ theme }) => theme.spacing(4)};
    flex: 1 1 auto;

    svg {
      width: 16px;
    }
  }
`;
exports.StyledInfoIcon = (0, styled_components_1.default)(icons_1.InfoIcon) `
  && {
    fill: none;
    width: 16px;
    vertical-align: bottom;

    rect,
    path {
      stroke: ${ui_components_1.baseColors.primaryBlueMed400};
    }
  }
`;
